export default __webpack_public_path__ + "static/media/loader.55c302c9.svg";